<template lang="html">

  <v-text-field @input="onInput" v-model="formattedValue"
      :error-messages="errorMessages"
      :label="label"
      v-money="{precision, decimal, thousands, prefix, suffix}">
  </v-text-field>

</template>

<script>

import money, { defaults } from './PrMoneyDirective';
import { format, unformat } from './PrMoneyUtilFormat';

export default {

  props: {
    value: {
      required: true,
      type: [Number, String],
      default: '',
    },
    masked: {
      type: Boolean,
      default: false,
    },
    precision: {
      type: Number,
      default: () => defaults.precision,
    },
    decimal: {
      type: String,
      default: () => defaults.decimal,
    },
    thousands: {
      type: String,
      default: () => defaults.thousands,
    },
    prefix: {
      type: String,
      default: () => defaults.prefix,
    },
    suffix: {
      type: String,
      default: () => defaults.suffix,
    },
    label: {
      type: String,
      default: 'Data',
    },
    errorMessages: {
      default() {
        return [];
      },
    },
  },
  directives: { money },
  data() {
    return {
      formattedValue: '',
      increment: 0,
    };
  },
  mounted() {
    this.formattedValue = this.value;
  },
  watch: {
    value: {
      handler(newValue) {
        const formatted = format(newValue, this.$props);
        if (formatted !== this.formattedValue) {
          this.formattedValue = formatted;
        }
      },
    },
  },
  methods: {
    onInput(evt) {
      this.$emit('input',
        this.masked ? evt : unformat(evt, this.precision));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/widgets/PrInputMoney.vue